export const initialErrorData = {
  email: '',
  address: '',
  phone_number: '',
  name: '',
  surname: '',
};
